import { youtubeThumbnailUrl } from "../lib/youtubeVideos";

const FALLBACK_QUALITIES = ["sd", "hq"];

/**
 * YouTube poster image — prefers maxres (1280×720), falls back to sd/hq if missing.
 */
export default function YoutubeThumbnail({
  videoId,
  alt = "",
  className,
  loading = "lazy",
  decoding = "async",
  fetchPriority,
}) {
  const id = String(videoId || "").trim();
  if (!id) return null;

  const handleError = (event) => {
    const img = event.currentTarget;
    const step = Number.parseInt(img.dataset.fallbackStep || "0", 10);
    const nextQuality = FALLBACK_QUALITIES[step];
    if (!nextQuality) return;
    img.dataset.fallbackStep = String(step + 1);
    img.src = youtubeThumbnailUrl(id, nextQuality);
  };

  return (
    <img
      src={youtubeThumbnailUrl(id, "maxres")}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      fetchPriority={fetchPriority}
      data-fallback-step="0"
      onError={handleError}
    />
  );
}
